<template>
    <div class="authorization-hours" v-if="durations.length > 0">
        <span class="authorization-hours__title" v-html="$t('AuthorizationHours.title')"></span>
        <TotemAuthorizationHours :durations="durations" />
    </div>
</template>

<script>
    export default {
        props: {
            durations: Array,
        }
    }
</script>

<style lang="scss" scoped>
    .authorization-hours {
        display: flex;
        flex-direction: column;
        background-color: $heavy_metal;
        margin: 0 0 20px;
        position: relative;
        padding: 10px 20px 20px 20px;
        overflow-y: auto;
        overflow-x: hidden;
        width: 300px;

        [class*="desktop_xxxl"] & {
          width: 370px;
        }
        [class*="mobile"] & {
          width: 100%;
        }

        &__title {
            font-size: 1.6rem;
            margin: 0 0 20px;
            color: $white;
            font-family: Quicksand-Bold, sans-serif;
        }
    }
</style>
